import React from "react";
import OrderedModuleEditor from "@/components/common/OrderedModuleEditor";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Field = ({ label, children, hint }) => (
  <div className="space-y-1">
    <Label className="text-xs text-white/50">{label}</Label>
    {children}
    {hint && <p className="text-[11px] text-white/40">{hint}</p>}
  </div>
);

export default function Stats() {
  return (
    <OrderedModuleEditor
      resource="admin/site/stats"
      singular="stat"
      title="Stats & Counters"
      subtitle="Drag to reorder homepage counters."
      titleKey="label"
      defaultValues={{ order: 1, number: "0", prefix: "", suffix: "", label: "", status: "published" }}
      enableStatus
      getItemLabel={(it, idx) => it.label || `Stat ${idx + 1}`}
      renderPreviewItem={(it) => (
        <div className="text-center py-2">
          <div className="text-2xl font-bold text-white font-mono">
            {it.prefix || ""}{it.number || "0"}{it.suffix || ""}
          </div>
          <div className="text-xs text-white/50 mt-1">{it.label || "Label"}</div>
        </div>
      )}
      renderInspector={(item, patch) => (
        <>
          <Field label="Number" hint="e.g. 100, 7, 98">
            <Input value={item.number || ""} onChange={(e) => patch({ number: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Prefix">
              <Input value={item.prefix || ""} onChange={(e) => patch({ prefix: e.target.value })} placeholder="$" className="bg-black/20 border-white/10 text-white" />
            </Field>
            <Field label="Suffix">
              <Input value={item.suffix || ""} onChange={(e) => patch({ suffix: e.target.value })} placeholder="+" className="bg-black/20 border-white/10 text-white" />
            </Field>
          </div>
          <Field label="Label">
            <Input value={item.label || ""} onChange={(e) => patch({ label: e.target.value })} className="bg-black/20 border-white/10 text-white" />
          </Field>
        </>
      )}
    />
  );
}
